import React from "react";
import { Person } from "./types";

export default ({
  imageUrl,
  firstName,
  lastName,
  category,
  classYear,
  nationalityCode,
  profileUrl,
  articleUrl = "",
  quote,
  achievements
}: Person) => {
  const cropResize = (url?: string) =>
    url &&
    url
      .replace("&height=416", "&height=512")
      .replace("&width=768", "&width=567");

  const linkFlag =
    (category == "Contributor" && articleUrl) || category == "Player";
  return (
    <>
      <div
        className={`hall-of-fame__inductee ${category}${
          linkFlag ? "" : " no-link"
        }`}
      >
        <div
          style={{ backgroundImage: `url("${cropResize(imageUrl)}")` }}
          className="hall-of-fame__img"
        ></div>
        <div className="hall-of-fame__inductee-details">
          <div className="hall-of-fame__inductee-name">
            <div className="hall-of-fame__inductee-firstname">{firstName}</div>
            <div className="hall-of-fame__inductee-lastname">{lastName}</div>
            <div className="hall-of-fame__inductee-category">{category}</div>
          </div>
          <div className="hall-of-fame__inductee-class">
            <div
              className={`hall-of-fame__inductee-nationality itf-flags itf-flags--${nationalityCode}`}
            ></div>
            <div className="hall-of-fame__inductee-class-year desktop">
              {classYear}
              <br /> Inductee
            </div>
            <div className="hall-of-fame__inductee-class-year mobile">
              {classYear} Inductee
            </div>
          </div>
          {(category == "Contributor" && articleUrl) || category == "Player" ? (
            <a
              target="_blank"
              href={category == "Player" ? profileUrl : articleUrl}
              className="hall-of-fame__inductee-cta"
            >
              <span>
                {category == "Player" ? "See Profile" : "See article"}
              </span>
            </a>
          ) : null}
        </div>
      </div>
      <div className="hall-of-fame__inductee-expanded">
        {quote ? <div className="quote">{quote}</div> : null}
        {achievements.length ? (
          <div className="achievements">
            <h3>Achievements</h3>
            <div className="achievements__wrapper">
              {achievements.map((achieved, key) => (
                <div key={key} className="achievements-item">
                  <div className="label">{achieved.label}</div>
                  <div className="value">{achieved.value}</div>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};
